import { Colorway, Select } from '@fourthwall/components';
import React from 'react';
export const OfferImagesFilters = ({ filters, onColorFilterSort, }) => {
    return filters.map((filter) => {
        if (filter.type === 'COLOR') {
            return (React.createElement(Colorway, { colors: filter.options.map((option) => ({ ...option, value: option.color })), activeColor: filter.value, onSortChange: filter.tag === 'COLOR' ? onColorFilterSort : undefined, onChange: (option) => filter.onChange(option.label), isDraggable: true }));
        }
        return (React.createElement(Select, { label: filter.label, options: filter.options, value: filter.value, onValueChange: filter.onChange }));
    });
};
